export default "/images/vendor/flag-icons/flags/1x1/hk.svg?b80f4f843c33522190c6089efa2c7f9d";